import React from 'react';
import { FormattedMessage } from 'react-intl';

import { countryCode } from 'Helpers/Geo/data';

import 'Components/PaymentCards/PaymentCards.scss';

export default function PaymentCards() {
  function getCards() {
    let paymentMethods = [];

    switch (countryCode.toLowerCase()) {
      case 'us':
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'alipay', 'discover', 'american-express', 'unionpay', 'jcb'];
        break;
      case 'cn':
        paymentMethods = ['alipay', 'paypal', 'unionpay', 'googlepay', 'visa', 'mastercard', 'jcb', 'american-express'];
        break;
      case 'gb':
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'american-express', 'discover', 'unionpay'];
        break;
      case 'de':
        paymentMethods = ['paypal', 'visa', 'googlepay', 'ideal', 'mastercard', 'american-express', 'cartebancaire', 'discover'];
        break;
      case 'ca':
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'american-express', 'discover', 'unionpay'];
        break;
      case 'au':
        paymentMethods = ['paypal', 'mastercard', 'visa', 'googlepay', 'american-express', 'diners'];
        break;
      case 'fr':
        paymentMethods = ['paypal', 'cartebancaire', 'visa', 'googlepay', 'mastercard', 'american-express'];
        break;
      case 'ru':
        paymentMethods = ['mastercard', 'visa', 'paypal', 'googlepay', 'jcb', 'discover', 'american-express'];
        break;
      case 'es':
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'american-express', 'cartebancaire'];
        break;
      case 'jp':
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'jcb', 'alipay', 'american-express', 'unionpay'];
        break;
      case 'pl':
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'cartebancaire', 'american-express'];
        break;
      case 'kr':
        paymentMethods = ['paypal', 'mastercard', 'visa', 'googlepay', 'unionpay', 'american-express', 'jcb', 'discover'];
        break;
      case 'nl':
        paymentMethods = ['ideal', 'paypal', 'mastercard', 'googlepay', 'visa', 'american-express', 'cartebancaire'];
        break;
      case 'it':
        paymentMethods = ['paypal', 'mastercard', 'visa', 'googlepay', 'american-express', 'cartebancaire'];
        break;
      case 'hk':
        paymentMethods = ['alipay', 'paypal', 'mastercard', 'googlepay', 'visa', 'discover', 'unionpay', 'american-express', 'jcb'];
        break;
      default:
        paymentMethods = ['paypal', 'visa', 'mastercard', 'googlepay', 'alipay', 'american-express', 'discover', 'jcb', 'ideal', 'sofort', 'unionpay'];
    }

    return (
      <React.Fragment>
        {paymentMethods.slice(0, 5).map(paymentMethod =>
          <div key={paymentMethod} className="payment-column">
            <div className={`payment-image ${paymentMethod}`}>
              <img
                loading="lazy"
                alt={paymentMethod}
                src={`https://cdn.fanatical.com/production/product/payment-methods-cart/svg/${paymentMethod}.svg`}
                className="border-gray"
              />
            </div>
          </div>,
        )}
      </React.Fragment>
    );
  }

  return (
    <div className="product-ways-to-pay">
      {window.locale === 'en' &&
        <div className="title-container">
          <FormattedMessage id="paymentcards.pay-title" defaultMessage="Payments:" />
        </div>
      }
      <div className="payment-images-container">
        {getCards()}
      </div>
    </div>
  );
}
